import React from 'react'
import PropTypes from 'prop-types'
import LinkChooser from '../links/linkChooser'
import s from './button.module.css'
import { ArrowRight } from '../../../src/svg/arrow_right'
import { GTMEvents } from '../../lib/GTMevents'

const themes = {
  size: {
    big: s.big,
    medium: s.medium,
    small: s.small,
  },
  color: {
    orange: s.orange,
    white: s.white,
    transparent: s.transparent,
    whiteFlat: s.whiteFlat,
    outlineWhite: s.outlineWhite,
    outlineRed: s.outlineRed,
    outlineTurquoise: s.outlineTurquoise,
    turquoise: s.turquoise
  },
}

const Btn = props => {
  if (['button', 'submit'].includes(props.type)) {
    return (
      <button
        id={props.id ? props.id : undefined}
        className={`
          ${props.isPill ? s.pill : ''}
          ${s.button}
          ${themes.size[props.size]}
          ${themes.color[props.color]}
          ${props.className}
          ${props.disabled ? s.orangeDisabled : ''}
        `}
        onClick={props.onClick}
        disabled={props.disabled}
        type={props.type}
        {...props.attributes}
      >
        {props.label}   
      </button>
    )
  } else if (props.type === 'link') {
    return  (
      <ButtonWrapper
        GTM={props.GTM}
        GTMOption={props.GTMOption}
        size={props.size}
        isPill={props.isPill}
        color={props.color}
        wrapClass={props.wrapClass}
        className={props.className}
        label={props.label}
        title={props.title}
      >
        <LinkChooser
          id={props.id ? props.id : undefined}
          onClick={props.onClick}
          to={props.href}
        >
          {props.label} {props.arrowRight && (
            <span >
              <ArrowRight className={`${s.positionIcon}`} width={20} height={20} fill={'#FFF'} />
            </span> 
          )}    
        </LinkChooser>
      </ButtonWrapper>
    )
  }
}

const ButtonWrapper = props => (
  <div
    onClick={props.GTM && props.GTMOption.section.length>0 ? ()=> GTMEvents.TypeContributionBtnDownload(props.GTMOption.section,props.GTMOption.sub_sec,`${props.title} | ${props.label}`,props.GTMOption.location): ()=> GTMEvents.TypeContributionCuentaMetasBtnDocument('tipos de aporte','Documentos informativos y formatos',`${props.title} | ${props.label}`,'/aportes-y-fondo/tipos-de-aportes/aportes-voluntarios') }
    className={` ${props.isPill ? s.pill : ''} ${s.button} ${
      themes.size[props.size]
    } ${themes.color[props.color]} ${props.className}`}
  >
    {props.children}
  </div>
)

ButtonWrapper.defaultProps = {
  GTMOption: {section:'',sub_sec:'', option: '', location: ''},
  color: 'orange',
  label:'',
}
ButtonWrapper.propTypes = {
  color: PropTypes.oneOf([
    'orange',
    'white',
    'whiteFlat',
    'outlineWhite',
    'outlineRed',
    'transparent',
    'outlineTurquoise',
    'turquoise'
  ]),
  label:PropTypes.any,
  GTMOption: PropTypes.any,
  isPill:PropTypes.any,
  size: PropTypes.any,
  className: PropTypes.any,
  GTM:PropTypes.any,
}


Btn.defaultProps = {
  type: 'link',
  GTM: false,
  GTMOption: {section:'',sub_sec:'', option: '', location: ''},
  color: 'orange',
  size: 'big',
  id: false,
  style: 'solid',
  isPill: false,
  className: '',
  href: '/',
}

Btn.propTypes = {
  type: PropTypes.oneOf(['gatsby-link', 'button', 'link', 'submit']),
  color: PropTypes.oneOf([
    'orange',
    'white',
    'whiteFlat',
    'outlineWhite',
    'outlineRed',
    'transparent',
    'outlineTurquoise',
    'turquoise'
  ]),
  size: PropTypes.oneOf(['big', 'small', 'medium']),
  GTMOption: PropTypes.any,
}

export default Btn
